import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Button from '../Button';
import './_noresults.scss';

const propTypes = {
    /** The content */
    children: PropTypes.node.isRequired,

    /** The button's label. If empty the button won't be displayed */
    buttonLabel: PropTypes.node,

    /** Called when user click on the button */
    onButtonClick: PropTypes.func,
    gtmAttribute: PropTypes.string,
    extraClass: PropTypes.string,
};

const defaultPropTypes = {
    buttonLabel: '',
    onButtonClick: null,
    gtmAttribute: null,
    extraClass: '',
};

const NoResults = (props) => {
    const {
        children,
        buttonLabel,
        onButtonClick,
        gtmAttribute,
        extraClass,
    } = props;

    const className = classNames('c-noresults', extraClass);

    return (
        <div className={className}>
            <div className="c-noresults__icon"></div>
            <div className="c-noresults__content">
                { children }
            </div>
            {buttonLabel &&
                <div className="c-noresults__button">
                    <Button
                        label={buttonLabel}
                        onClick={onButtonClick}
                        primary
                        data-spectate-product={gtmAttribute}
                    />
                </div>
            }
        </div>
    );
};

NoResults.propTypes = propTypes;
NoResults.defaultPropTypes = defaultPropTypes;

export default NoResults;
